import type { SVGProps } from "react";
export interface HandHeartIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HandHeartIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HandHeartIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M13.957.875c.936 0 1.747.48 2.29 1.102a3.52 3.52 0 0 1 .873 2.408l.002.001c-.037 1.226-.759 2.166-1.42 2.852l-.278.28c-.49.48-.96.924-1.365 1.3l-.98.897a1.615 1.615 0 0 1-2.04.098l-.118-.098a75 75 0 0 1-1.633-1.508l-.715-.689c-.719-.703-1.656-1.73-1.698-3.132l.001-.001a3.53 3.53 0 0 1 .875-2.408C8.294 1.354 9.104.875 10.039.875c.866 0 1.5.308 1.959.688.458-.38 1.093-.688 1.96-.688Zm0 2.25c-.293 0-.459.102-.587.229a1.4 1.4 0 0 0-.202.26l-.157.295v.001l-.028.05-.022.04a1 1 0 0 1-.174.216 1.1 1.1 0 0 1-.299.217 1.1 1.1 0 0 1-.38.103 1.1 1.1 0 0 1-.32-.015 1 1 0 0 1-.157-.038q-.003 0-.005-.002a1 1 0 0 1-.118-.048l-.061-.034-.022-.011a1.1 1.1 0 0 1-.213-.169 1.1 1.1 0 0 1-.178-.221l-.02-.04q-.016-.023-.027-.048l-.002-.001c-.097-.203-.2-.4-.357-.555-.128-.127-.295-.229-.589-.229-.148 0-.377.084-.593.331a1.3 1.3 0 0 0-.32.747l-.002.113v.003l.019.161c.073.38.372.813 1.003 1.43l.693.668c.439.417.84.784 1.159 1.075A74 74 0 0 0 13.85 5.91l.25-.254c.539-.567.761-.969.772-1.337v-.003l-.003-.113a1.3 1.3 0 0 0-.32-.747c-.215-.247-.445-.331-.593-.331Zm-8.367 8.75c.67 0 1.335.094 1.978.28l3.14.906.197.05q.297.063.602.063h2.284a2.77 2.77 0 0 1 2.737 2.345l2.742-.989.282-.086a2.877 2.877 0 0 1 3.401 1.806l.087.282a2.875 2.875 0 0 1-1.808 3.404l-7.516 2.727a7.63 7.63 0 0 1-6.245-.47l-3.605-1.961a.9.9 0 0 0-.419-.107h-1.43a1.125 1.125 0 0 1 0-2.25h1.43c.522 0 1.036.13 1.494.38l3.605 1.962.257.13a5.38 5.38 0 0 0 4.145.201l7.516-2.727a.625.625 0 0 0 .406-.679l-.03-.123a.626.626 0 0 0-.802-.373l-.001.001-5.258 1.896-.096.035-.002-.002-.032.014a2.8 2.8 0 0 1-.858.134H9.938a1.125 1.125 0 0 1 0-2.25h3.851a.6.6 0 0 0 .159-.024l.045-.017a.525.525 0 0 0-.204-1.009h-2.283a5.1 5.1 0 0 1-1.422-.2l-3.141-.907a4.9 4.9 0 0 0-1.354-.192H2a1.125 1.125 0 0 1 0-2.25z"
      />
    </svg>
  );
}
